import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLang } from "@/context/LanguageContext";
import { PostCard } from "@/components/PostCard";
import { PageShell } from "@/components/PageShell";
import { api } from "@/lib/api";

export default function BlogPage() {
  const { t } = useLang();
  const [filter, setFilter] = useState("all");
  const { data: posts = [], isLoading } = useQuery({
    queryKey: ["posts", filter],
    queryFn: () => api(`/api/posts?limit=60${filter === "all" ? "" : `&category=${filter}`}`),
  });

  return (
    <PageShell eyebrow={t.blog.pageEyebrow} title={t.blog.pageTitle} titleItalic={t.blog.pageTitleItalic} description={t.blog.pageDescription} testId="blog-page">
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="Post categories">
        {Object.entries(t.blog.filters).map(([id, label]) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={filter === id}
            onClick={() => setFilter(id)}
            data-testid={`blog-filter-${id}`}
            className={`rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-colors duration-300 ${
              filter === id ? "border-ember bg-ember text-ink" : "border-line text-ash hover:border-ember/60 hover:text-cream"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {isLoading ? (
        <p className="mt-14 text-sm text-ash" data-testid="blog-loading">{t.blog.loading}</p>
      ) : posts.length === 0 ? (
        <p className="mt-14 text-sm text-ash" data-testid="blog-empty">{t.blog.empty}</p>
      ) : (
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
          {posts.map((post, i) => (
            <PostCard key={post.id} post={post} testId={`blog-post-${i}`} large={i === 0} />
          ))}
        </div>
      )}
    </PageShell>
  );
}
